import styled from 'styled-components';
import { NavigationAndActionSingleTick } from '../icons';
import { theme } from '../theme';

interface StyledCheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  error?: boolean;
}

interface StyledCheckboxTickProps {
  checked: boolean;
}

// The default browser checkbox is hidden.
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

// An outside square containing a checkmark as a child.
export const StyledCheckbox = styled.span<StyledCheckboxProps>`
  height: ${theme.fontSizes.body};
  width: ${theme.fontSizes.body};

  background-color: ${({theme}) => theme.colors.primaryW};
  border-style: solid;

  border-color: ${(props) => {
    if (props.disabled) {
      return props.theme.colors.primaryK3;
    }

    if (props.error) {
      return props.theme.colors.primaryR5;
    }

    return props.theme.colors.primaryK10;
  }};

  border-width: ${(props) => (props.error ? '2px' : '1px')};

  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 7px;
`;

// Container is a label, so that clicking anywhere checks the checkbox.
export const StyledCheckboxContainer = styled.label<StyledCheckboxProps>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: var(--main-font-size);

  color: ${(props) =>
    props.disabled ? props.theme.colors.primaryK3 : props.theme.colors.primaryK10};

  /* Radio button changes when anything in the container is hovered over. */
  &:hover ${StyledCheckbox} {
    ${(props) =>
      !props.disabled && `background-color: ${props.theme.colors.primaryK5};`};
    ${(props) =>
      !props.disabled &&
      !props.error &&
      `border-color: ${props.theme.colors.primaryK7};`}
  }
`;

// A checkmark icon that is displayed only when the checkbox is clicked.
export const StyledCheckmark = styled(
  NavigationAndActionSingleTick,
)<StyledCheckboxTickProps>`
  height: 70%;
  width: 70%;
  display: ${(props) => (props.checked ? 'block' : 'none')};

  g {
    fill: ${({theme}) => theme.colors.primaryT2};
  }
`;
